import { Globe, MapPin, Newspaper } from "lucide-react";
import { Reveal, SectionLabel } from "@/components/Reveal";

const ITEMS = [
  { icon: Newspaper, label: "Jewish" },
  { icon: MapPin, label: "Israel" },
  { icon: Globe, label: "Worldwide" },
];

const About = () => (
  <section
    id="about"
    data-testid="about-section"
    className="relative overflow-hidden border-t border-white/5 bg-ink py-14 lg:py-16"
  >
    <div aria-hidden className="dot-grid absolute inset-0 opacity-30" />
    <div className="relative mx-auto max-w-7xl px-5 lg:px-10">
      <div className="max-w-2xl">
        <Reveal>
          <SectionLabel>About JGW</SectionLabel>
          <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-white md:text-4xl">
            Keeping Jewish Communities Connected
          </h2>
          <div className="mt-5 h-px w-16 bg-gradient-to-r from-silver/60 to-transparent" />
          <p className="mt-5 text-base leading-relaxed text-silver md:text-lg">
            Jewish Global Wire delivers timely and relevant Jewish, Israel, and
            worldwide updates conveniently through WhatsApp.
          </p>
        </Reveal>
      </div>

      <div className="mt-9 grid gap-4 sm:grid-cols-3">
        {ITEMS.map((item, i) => (
          <Reveal key={item.label} delay={i * 0.07}>
            <div
              data-testid={`about-item-${item.label.toLowerCase()}`}
              className="flex items-center gap-4 rounded-xl border border-white/10 bg-white/[0.04] px-6 py-5 transition-colors duration-200 hover:border-white/25 hover:bg-white/[0.07]"
            >
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-white/10 bg-black/50 text-silver-light">
                <item.icon size={17} strokeWidth={2} />
              </span>
              <span className="text-[15px] font-bold tracking-wide text-white">{item.label}</span>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default About;
